import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useToaster } from '@components/toaster';

import { useStore } from 'models/Provider';

import { getDepartmentOrder, pinDepartment, SubmitError, unpinDepartment } from './requests';

export const useDepartmentOrderingList = () => {
  const { showError } = useToaster();
  const { t } = useStore();
  return useQuery({
    queryKey: ['department-order-data'],
    queryFn: getDepartmentOrder,
    onError: () => {
      showError(t('company.settings.joborder.toast.get.error'));
    },
  });
};

export const usePinDepartment = () => {
  const { t } = useStore();
  const { showError, showSuccess } = useToaster();
  const queryClient = useQueryClient();
  return useMutation(
    (data: { departmentId: number; ordering: number }) =>
      pinDepartment(data.departmentId, data.ordering),
    {
      mutationKey: ['pin-department'],
      onSuccess: () => {
        queryClient.invalidateQueries(['department-order-data']);
        showSuccess(t('company.settings.joborder.toast.department'));
      },
      onError: (error: SubmitError) => {
        showError(
          error.response
            ? (error.response.data.error ?? error.response.data.ordering)
            : error.message,
        );
      },
    },
  );
};

export const useUnPinDepartment = () => {
  const { t } = useStore();
  const { showError, showSuccess } = useToaster();
  const queryClient = useQueryClient();
  return useMutation((departmentId: number) => unpinDepartment(departmentId), {
    mutationKey: ['unpin-department'],
    onSuccess: () => {
      queryClient.invalidateQueries(['department-order-data']);
      showSuccess(t('company.settings.joborder.toast.department'));
    },
    onError: (error: SubmitError) => {
      showError(error.response ? error.response.data.error : error.message);
    },
  });
};
